module.exports = __webpack_public_path__ + "assets/img/36_549_big.92fea656.jpg";